export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.eot?7eefe04dc985dd4ad38bd7f4ec0c20a0";